module.exports = __webpack_public_path__ + "static/media/pixels.1df8e853.png";